<template>
  <div id="app">
    <main v-if="loaded">
      <header>
        <h1>Startup <span>Challenge Generator</span></h1>
        <img src="./assets/logo.jpg" alt="">
      </header>
 
      <div class="controls">
        <button class="outofthebox icon-arrows-cw" @click="setChallenge('outofthebox');">Out of the Box Challenge</button>
        <button class="impact icon-arrows-cw" @click="setChallenge('impact');">Impact Challenge</button>
      </div>    
       
      <span v-if="challenge_type === 'outofthebox'" class="challenge"> 
        Bedenk een startup voor <span :class="challenge_type">{{ challenge }}</span> met behulp van <span :class="{ 'editable': editable}" :contenteditable="editable">{{ onderwerp }}</span>?
      </span>
        <span v-else class="challenge"> 
        Hoe kan je <span :class="{ 'editable': editable}" :contenteditable="editable">{{ onderwerp }}</span>  met behulp van <span :class="challenge_type">{{ challenge }}</span>?
      </span>
    </main>

    <section class="cta container">
          <h4>Impact maken én harde euro's verdienen met jouw zojuist verzonnen idee?</h4>
          <a href="https://www.praatpaal.online" target="_blank" class="btn">Start nu met startup program!</a>
    </section>

    <footer  v-if="loaded">

      <div class="container">
        <div class="text">
          <h4>Waarom</h4>
          <p>Een goed begin, is het halve werk. Startup Challengegenerator helpt jou jouw business ideeën aan te scherpen en je horizon te verbreden. Door zicht te hebben op hedendaagse uitdagingen en technologieën komen we tot oplossingen meer die impact genereren voor mens, maatschappij en voor je eigen ondernemerschap carrière.</p>
        </div>
        <div class="credit">
          <p>
            <h4>
            Inspiratie</h4>
            <p>
            Startup Program Community,  <a target="_blank" href="https://challengegenerator.nl">Challengegenerator.nl</a> van Brain Fuel, Sustainable Development Goals, Bright TV, startup ecosysteem partners en veel cafeïne.
          </p>
    
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
import yaml from 'js-yaml';

export default {
  name: 'App',
  data() {
    return {
      data: null,
      challenges: null,
      onderwerp: null,
      challenge: null,
      challenge_type: null,
      editable: false,
      loaded: false
    }
  },
  mounted() {
    fetch('challenges.txt')
     .then( response => response.text() )
    .then( data => {
       var data = yaml.safeLoad( data );
       this.challenges = data;
       this.loaded = true;
       this.setChallenge('outofthebox');
       this.setOnderwerp();
    });
  },
  methods: {
    setOnderwerp: function() { 
      let vorig_onderwerp = this.onderwerp;
      let onderwerp = null;

      if ( this.challenge_type == "outofthebox")  onderwerp = this.challenges.Gekkefactor[ Math.floor(Math.random() * this.challenges.Gekkefactor.length  ) ];
      if ( this.challenge_type == "impact") onderwerp = this.challenges.Worldchallenge[ Math.floor(Math.random() * this.challenges.Worldchallenge.length  ) ];
      
      if ( onderwerp == vorig_onderwerp) this.setOnderwerp(); else  this.onderwerp = onderwerp;

    },
    setChallenge: function(c) {
      let challenge = null
      this.challenge_type = c;
      let vorige_challenge = this.challenge;

      if ( c == "outofthebox") challenge = this.challenges.Doelgroep[ Math.floor(Math.random() * this.challenges.Doelgroep.length  ) ];
      if ( c == "impact") challenge = this.challenges.Technologie[ Math.floor(Math.random() * this.challenges.Technologie.length  ) ];

      if ( challenge == vorige_challenge) {
        this.setChallenge(c);  
      }
      else
      { 
        this.challenge = challenge;
        this.setOnderwerp();
      }
    },
  }
}
</script>

<style lang="scss">
@import "style.scss";
</style>
